import './statusBadge.css';

const StatusBadge = ({ status }) => {
    const getStatusData = (status) => {
        switch (status) {
            case 'Joined':
                return {
                    bg: "#e6f4ea",
                    color: "#22A06B",
                    icon: "✓",
                    tooltip: "User is currently a member of this organization"
                };
            case 'Requested':
            case 'Pending':
                return {
                    bg: "#fff8e1",
                    color: "#b38600",
                    icon: "⏳",
                    tooltip: "Request is pending approval"
                };
            case 'Remove-Requested':
                return {
                    bg: "#ffebee",
                    color: "#d32f2f",
                    icon: "⏳",
                    tooltip: "Removal request is pending"
                };
            case 'Rejected':
                return {
                    bg: "#ffebee",
                    color: "#d32f2f",
                    icon: "✗",
                    tooltip: "User's request to join was rejected"
                };
            case 'Removed':
                return {
                    bg: "#ffeaea",
                    color: "#d32f2f",
                    icon: "✗",
                    tooltip: "User was removed from this organization"
                };
            case 'Not-Requested':
                return {
                    bg: "#f0f0f0",
                    color: "#6f6c6c",
                    icon: "○",
                    tooltip: "User has not requested access"
                };
            default:
                return {
                    bg: "#f0f0f0",
                    color: "#6f6c6c",
                    icon: "○",
                    tooltip: status
                };
        }
    };


    const { bg, color, icon, tooltip } = getStatusData(status);

    // Use a single uniform font size for all statuses
    const badgeFontSize = 12;

    return (
        <div title={tooltip} style={{
            display: "inline-block",
            width: "140px",
        }}>
            <span className="sansSerifFont" style={{
                background: bg,
                color,
                borderRadius: 20,
                padding: "4px 12px",
                fontWeight: 600,
                fontSize: badgeFontSize,
                letterSpacing: 0.2,
                textTransform: "capitalize",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                justifyContent: "center",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                minWidth: "120px",
                width: "100%",
                maxWidth: "140px",
            }}>
                <span style={{ fontSize: badgeFontSize, lineHeight: 1 }}>{icon}</span>
                {status}
            </span>
        </div>
    );
};

export default StatusBadge;